import "./Loader.css";

const Loader = ({ isOpen, message }) => {
  if (!isOpen) return null;

  return (
    <div className="global-loader" aria-live="polite" aria-busy="true">
      <div className="global-loader__content">
        <div className="global-loader__spinner" />
        {message && <div className="global-loader__message">{message}</div>}
      </div>
    </div>
  );
};

export default Loader;
